import React from 'react';

const DropdownCascadeSimple = ({ data, selectedBUs, handleBUSelect, selectedTribes, handleTribeChange, selectedMetiers, handleMetierChange }) => {

    const handleTribeChangeInternal = (buId, selectedValue) => {
        handleTribeChange(buId, selectedValue);
    };

    const handleMetierChangeInternal = (buId, tribeId, selectedValue) => {
        handleMetierChange(buId, tribeId, selectedValue);
    };

    return (
        <div>
            <small className="text-white fst-italic mb-3" style={{ fontSize: "11px" }}>
                *Veuillez choisir un ou plusieurs Business Unit
            </small>
            <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
                {data.map(bu => (
                    <div key={`bu-${bu.buId}`} style={{ margin: '10px' }}>
                        <button
                            className={`btn_primary mb-2 ${selectedBUs.includes(bu.buId) ? 'active' : ''}`}
                            onClick={() => handleBUSelect(bu.buId)}
                            style={{
                                backgroundColor: selectedBUs.includes(bu.buId) ? '#fff' : '',
                                color: selectedBUs.includes(bu.buId) ? '#3c3b3b' : '',
                            }}
                        >
                            {bu.buName}
                        </button>
                        {selectedBUs.includes(bu.buId) && (
                            <div>
                                <select
                                    className='form-select text-muted select-input mb-2'
                                    style={{ width: '150px' }}
                                    value={selectedTribes[bu.buId] || ''}
                                    onChange={(e) => handleTribeChangeInternal(bu.buId, e.target.value)}
                                >
                                    <option value="">Sélec. Tribe</option>
                                    {bu.tribes.map(tribe => (
                                        <option key={`tribe-${tribe.tribeId}`} value={tribe.tribeId}>{tribe.tribeName}</option>
                                    ))}
                                </select>
                                {selectedTribes[bu.buId] && (
                                    <select
                                        className='form-select text-muted select-input mb-2'
                                        style={{ width: '150px' }}
                                        value=""
                                        onChange={(e) => handleMetierChangeInternal(bu.buId, selectedTribes[bu.buId], e.target.value)}
                                    >
                                        <option value="" disabled>Sélec. Métier</option>
                                        {bu.tribes
                                            .filter(tribe => tribe.tribeId.toString() === selectedTribes[bu.buId])
                                            .flatMap(tribe => tribe.metiers)
                                            .map(metier => (
                                                <option key={`metier-${metier.metierId}`} value={metier.metierId}>{metier.metierName}</option>
                                            ))}
                                    </select>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DropdownCascadeSimple;
